import React from 'react';
import { string, node, bool } from 'prop-types';
import classNames from 'classnames/bind';

import styles from './TripletItem.scss';

const cx = classNames.bind(styles);

/**
 * Note that order of title and content is reversed by CSS in order to keep
 * markup correct.
 */
export default function TripletItem({
  title,
  unitName,
  status,
  children,
  className,
  containsDevice,
}) {
  return (
    <div
      className={cx({
        TripletItem,
        [className]: !!className,
        [`status-${status}`]: status,
        [styles.containsDevice]: containsDevice,
      })}
    >
      <dt className={styles.context}>
        <span className={styles.title}>
          {title}
        </span>
        {unitName &&
          <span>
            {unitName}
          </span>}
      </dt>
      <dd className={styles.smallerText}>
        {children}
      </dd>
    </div>
  );
}

TripletItem.propTypes = {
  title: string.isRequired,
  unitName: string,
  status: string,
  children: node.isRequired,
  className: string,
  containsDevice: bool,
};



// WEBPACK FOOTER //
// ./src/components/DataPanel/TripletItem/index.js